import type { Bandwidth } from '@fs/zion-rootstech'
import { FALLBACK_BANDWIDTH } from '../../config/brightspot'

const VALID_BANDWIDTHS: readonly Bandwidth[] = ['good', 'fair', 'poor']

// useBandwidth() reports 'unknown' before it resolves, and otherwise whatever string
// Split has configured for the frontier_zion_bandwidthCategories treatment — which isn't
// guaranteed to be one of 'good'/'fair'/'poor'. getBrightspotConfig throws on anything
// else, so every value crossing that boundary must be normalized here first.
const normalizeBandwidth = (value: string): Bandwidth =>
  (VALID_BANDWIDTHS as readonly string[]).includes(value) ? (value as Bandwidth) : FALLBACK_BANDWIDTH

export default normalizeBandwidth
